import React, { useContext, useEffect, useMemo, useState } from 'react'

import { useSelector } from 'react-redux'
import { Modal, notification } from 'antd'
import { faCheck, faXmark } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import DataTable from '../../../Components/antd/Tables/DataTable/DataTable'
import { Action } from '../../../Components/antd/Tables/DataTable/utils/actions'
import { approveLinkRequest, rejectLinkRequest } from '../../../utils/api/linkRequest'
import { selectUser } from '../../../reducers/UserReducer'
import { getAllSchoolsPublic } from '../../../utils/api/school'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import Loading from '../../../Components/shared/Loading'

const LinkRequestManagementModal = ({ visible, data, onModalClose, title }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const { setPendingLinkRequests } = useContext(GlobalContext)

  const [schools, setSchools] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getAllSchoolsPublic(user).then(({ data }) => setSchools(data))
  }, [user.id])

  useEffect(() => {
    if (data && schools.length > 0) {
      setLoading(false)
    }
  }, [data, schools])

  const linkRequests = useMemo(() => {
    const parsedData = []

    if (data && schools.length > 0) {
      data.forEach(lr => {
        parsedData.push({ ...lr, school: schools.find(s => s.id === lr.source) })
      })
    }

    return parsedData
  }, [data, schools])

  const columns = useMemo(() => [
    {
      title: t('common.school'),
      key: lr => lr.school.abbreviation ?? lr.school.name ?? lr.school,
      tooltip: lr => lr.school?.name ?? 'UNKNOWN SCHOOL'
    }
  ], [t])

  const actions = useMemo(() => [
    new Action({
      color: 'green',
      icon: faCheck,
      title: 'common.approve',
      ghost: true,
      onClick: lr => {
        approveLinkRequest(user, lr).then(() => {
          notification.success({ message: t('common.link_request_approved'), placement: 'bottomRight' })
          setPendingLinkRequests(data.filter(plr => plr.id !== lr.id))
        })
      }
    }),
    new Action({
      color: 'red',
      icon: faXmark,
      title: 'common.reject',
      ghost: true,
      onClick: lr => {
        rejectLinkRequest(user, lr).then(() => {
          notification.success({ message: t('common.link_request_rejected'), placement: 'bottomRight' })
          setPendingLinkRequests(data.filter(plr => plr.id !== lr.id))
        })
      }
    })
  ], [t])

  return (
    <Modal onOk={onModalClose} cancelText={t('Cancel')} onCancel={onModalClose} visible={visible} title={title}>
      {loading ? <Loading /> : <DataTable data={linkRequests} columns={columns} actions={actions} />}
    </Modal>
  )
}

export default LinkRequestManagementModal
